import { createFileRoute } from '@tanstack/react-router';
import StatsPage from '@/features/admin/components/administration/StatsPage';
import { useAuth } from '@/features/auth/providers/AuthProvider';
import { StatsContentSkeleton } from '@/shared/components/feedback/skeletons';
import { AdminHeader, AdminPageLayout } from '@/shared/components/ui/AdminHeader';
import { TrendingUp } from 'lucide-react';
import { Navigate, useLocation } from '@tanstack/react-router';

export const Route = createFileRoute('/stats')({
  component: StatsRouteComponent,
});

function StatsRouteComponent() {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();

  const header = (
    <AdminHeader
      icon={TrendingUp}
      title="Office Analytics"
      description="Comprehensive insights into office activity across all your locations"
      variant="violet"
    />
  );

  if (authLoading) {
    return (
      <AdminPageLayout header={header}>
        <StatsContentSkeleton />
      </AdminPageLayout>
    );
  }

  if (!user) {
    return <Navigate to="/login" search={{ from: location.pathname }} />;
  }

  return <StatsPage />;
}
